import { render } from "./BlListFilterMatchString.vue?vue&type=template&id=3109c150&scoped=true"
import script from "./BlListFilterMatchString.vue?vue&type=script&lang=js"
export * from "./BlListFilterMatchString.vue?vue&type=script&lang=js"

import "./BlListFilterMatchString.vue?vue&type=style&index=0&id=3109c150&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3109c150"]])

export default __exports__